import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import { colorFormatter } from "../../fomatters/ColorFormatter";
import {
  createColorCreator,
  createColorEditor,
} from "../../editors/ColorEditor";

/**
 * TABLE SYSTEMCOLORS
 */
function FlagMessageType() {
  return (
    <Crud
      className="unlock-overflow"
      title="Flag Message Type"
      getUrl={() => "/Player/FlagMessageType_GetList"}
      // INSERT
      insertUrl={() => "/Player/FlagMessageType_Insert"}
      insertParams={({ userId }, { fkColor, bkColor, description }) => ({
        FkColor: fkColor,
        BkColor: bkColor,
        Description: description,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/FlagMessageType_Update"}
      updateParams={(
        { userId },
        { idFlagMessageType, fkColor, bkColor, description }
      ) => ({
        IdFlagMessageType: idFlagMessageType,
        FkColor: fkColor,
        BkColor: bkColor,
        Description: description,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/FlagMessageType_Delete"}
      deleteParams={({ userId }, id) => ({
        IdFlagMessageType: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idFlagMessageType"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="description"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Description
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataField="bkColor"
        dataFormat={colorFormatter}
        customEditor={{
          getElement: createColorEditor,
        }}
        customInsertEditor={{
          getElement: createColorCreator,
        }}
      >
        Background
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataField="fkColor"
        dataFormat={colorFormatter}
        customEditor={{
          getElement: createColorEditor,
        }}
        customInsertEditor={{
          getElement: createColorCreator,
        }}
      >
        Font
      </TableHeaderColumn>
    </Crud>
  );
}
// getElement(column: InsertModalColumnDescription, attr: EditableAttrs, editorClass: string, ignoreEditable: boolean, defaultValue: any): ReactElement | boolean;
// getElement(onUpdate: (updatedCell: TRow[K]) => void, props: CustomEditorProps<TRow, K>): ReactElement;

export default FlagMessageType;
